import './App.css';
import { BrowserRouter as Router, Routes, Route, useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ContactCard from './ContactCard';
import QRCodePage from './QRCodePage';
import AdminAuth from './AdminAuth';

// Person data objects
const personData = {
  fidlogic: {
    name: 'FidLogic IT Solutions',
    designation: 'Transforming ideas into impactful IT solutions',
    company: 'Collaborate with us to outsource your software development projects or hire a dedicated development team to achieve your goals. We offer comprehensive development services and solutions across various sectors at competitive rates.',
    website: 'www.fidlogic.com',
    email: 'contact@fidlogic.com',
    phone: '+1 (682) 453-1925',
    linkedin: 'https://www.linkedin.com/company/fidlogic/',
    linkedinText: 'linkedin.com/company/fidlogic/',
  },
  ak: {
    name: 'AK',
    designation: 'Managing Partner',
    company: 'FidLogic IT Solutions',
    website: 'www.fidlogic.com',
    email: 'contact@fidlogic.com',
    phone: '+1 (682) 453-1925',
    linkedin: 'https://www.linkedin.com/in/ak-fidlogic/',
    linkedinText: 'linkedin.com/in/ak-fidlogic/',
  },
  brkumar: {
    name: 'BR Kumar',
    designation: 'Managing Partner',
    company: 'FidLogic IT Solutions',
    website: 'www.fidlogic.com',
    email: 'contact@fidlogic.com',
    phone: '+1 (682) 453-1925',
    linkedin: 'https://www.linkedin.com/company/fidlogic/',
    linkedinText: 'linkedin.com/company/fidlogic/',
  },
  anooj: {
    name: 'A Chouksey',
    designation: 'Managing Partner',
    company: 'FidLogic IT Solutions',
    website: 'www.fidlogic.com',
    email: 'contact@fidlogic.com',
    phone: '+1 (682) 453-1925',
    linkedin: 'https://www.linkedin.com/company/fidlogic/',
    linkedinText: 'linkedin.com/company/fidlogic/',
  },
  mk: {
    name: 'MK Singh',
    designation: 'Managing Partner',
    company: 'FidLogic IT Solutions',
    website: 'www.fidlogic.com',
    email: 'contact@fidlogic.com',
    phone: '+1 (682) 453-1925',
    linkedin: 'https://www.linkedin.com/company/fidlogic/',
    linkedinText: 'linkedin.com/company/fidlogic/',
  },
  nithu: {
    name: 'Nithu Salim',
    designation: 'Owner',
    company: 'FidLogic IT Solutions',
    website: 'www.fidlogic.com',
    email: 'contact@fidlogic.com',
    phone: '+1 (682) 453-1925',
    linkedin: 'https://www.linkedin.com/company/fidlogic/',
    linkedinText: 'linkedin.com/company/fidlogic/',
  },
};

// Card Display Component
const CardDisplay = () => {
  const { person } = useParams();
  
  // Default to 'fidlogic' if no person specified or person not found
  // Convert to lowercase for case-insensitive matching
  const personKey = person ? person.toLowerCase() : 'fidlogic';
  const currentPerson = personData[personKey] || personData['fidlogic'];
  
  return <ContactCard person={currentPerson} />;
};

// Protected QR Code Route with Admin Auth
const ProtectedQRRoute = ({ personData }) => {
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const { person } = useParams(); // Call hooks at top level
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showAuth, setShowAuth] = useState(true);

  useEffect(() => {
    // Check if user is already authenticated in this session
    const isUserAuthenticated = sessionStorage.getItem('qrAuthToken');
    
    if (isUserAuthenticated) {
      // User is already logged in this session
      setIsAuthenticated(true);
      setShowAuth(false);
    } else {
      // User needs to login
      setShowAuth(true);
      setIsAuthenticated(false);
    }
  }, []);

  const handleAuthSuccess = () => {
    // Set auth token in sessionStorage to persist login during session
    sessionStorage.setItem('qrAuthToken', 'authenticated');
    setIsAuthenticated(true);
    setShowAuth(false);
  };

  const handleAuthCancel = () => {
    // Redirect to home
    navigate('/');
  };

  const handleLogout = () => {
    // Clear auth token and redirect to home
    sessionStorage.removeItem('qrAuthToken');
    setIsAuthenticated(false);
    setShowAuth(true);
    navigate('/');
  };

  if (showAuth) {
    return (
      <AdminAuth 
        onSuccess={handleAuthSuccess} 
        onCancel={handleAuthCancel}
      />
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return <QRCodePage personData={personData} onLogout={handleLogout} />;
};

// Main App with Router
function App() {
  return (
    <Router>
      <Routes>
        {/* Protected QR Code Routes */}
        <Route path="/qr/:person" element={<ProtectedQRRoute personData={personData} />} />
        <Route path="/qr" element={<ProtectedQRRoute personData={personData} />} />
        
        {/* Contact Card Routes */}
        <Route path="/:person" element={<CardDisplay />} />
        <Route path="/" element={<CardDisplay />} />
      </Routes>
    </Router>
  );
}

export default App;
